<template>
  <div class="ccer-main">
    <el-table
      :data="list"
      style="width: 100%; background: transparent"
      class="tableOne"
    >
      <el-table-column prop="name" label="设备名称" align="center" width="90">
      </el-table-column>
      <el-table-column prop="money" label="异常信息" align="center">
      </el-table-column>
      <el-table-column prop="proportion" label="等级" align="center">
      </el-table-column>
      <el-table-column prop="emissionreduction" label="发生时间" align="center">
      </el-table-column>
    </el-table>
    <div style="overflow: hidden">
      <vue-seamless-scroll
        :data="tableData"
        :class-option="optionHover"
        class="seamless-warp"
      >
        <el-table
          :data="tableData"
          border
          :show-header="status"
          style="width: 100%; background: transparent; border-width: 0px"
        >
          <el-table-column
            prop="name"
            label="设备名称"
            align="center"
            width="90"
          >
            <template slot-scope="scope">
              <span>{{ '设备'+scope.row.money }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="money" label="异常信息" align="center">
            <template slot-scope="scope">
              <span>{{ '设备'+scope.row.money+'出现异常或故障，请及时处理' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="proportion" label="等级" align="center">
            <template slot-scope="scope">
              <span>{{ '重要' }}</span>
            </template></el-table-column
          >
          <el-table-column
            prop="emissionreduction"
            label="发生时间"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ '2023-0'+scope.row.emissionreduction+'-21 00:00:00' }}</span>
            </template>
          </el-table-column>

        </el-table>
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
export default {
  name: "ccer",
  props: {
    tableData: {
      type: Array,
      default: null
    }
  },
  watch: {
    tableData (newValue) {
      if (newValue != null) {
        this.tableData = newValue
      }
    }
  },
  data () {
    return {
      list: [],

      status: false
    }
  },
  computed: {
    optionHover () {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    }
  },

  methods: {

  },
  mounted () {

  }
}
</script>

<style scoped>
.ccer-main {
  overflow: hidden;
}
.ccer-main /deep/ .el-table tr {
  background: transparent !important;
  color: #fff;
  border-width: 0px;
}
.ccer-main
  /deep/
  .el-table--enable-row-hover
  .el-table__body
  tr:hover
  > td.el-table__cell {
  background: transparent !important;
  border-width: 0px;
}
.ccer-main /deep/ .el-table td.el-table__cell,
.ccer-main /deep/ .el-table th.el-table__cell.is-leaf {
  border-width: 0px;
  background: transparent !important;
}
.ccer-main /deep/ .el-table::before {
  height: 0px;
}
.tableOne /deep/ .is-scrolling-none {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/right/ccer.vue